import React, { useContext, useEffect, useState } from "react";
import {
  ArrowClockwise,
  ArrowCounterclockwise,
  CheckCircleFill,
  ChevronDown,
} from "react-bootstrap-icons";


import LocationContext from "src/core/state/context/LocationContext";
import { calculateExchangeRate } from "src/core/utils/calculate-exchange-rate";
import calculateFee from "src/core/utils/calculate-fee";

import TransactionContext from "src/core/state/context/TransactionContext";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import numberFormatter from "src/core/utils/number-formatter";

const Calculator = (props) => {
  const { activeStep, setActiveStep } = props;
  const [fee, setFee] = useState(0);
  const [swapRate, setSwapRate] = useState(false);
  const [showCurrencyDropDown, setShowCurrencyDropDown] = useState(false);
  const [dropdownType, setDropdownType] = useState<"send" | "recieve">("send");
  const [exchangeRate, setExchangeRate] = useState("0");
  const [receiveInputFocused, setReceiveInputFocused] = useState(false);

  const {
    location: { locations },
  } = useContext(LocationContext);
  const {
    transaction: { transaction },
  } = useContext(TransactionContext);

  const [isFeeIncluded] = useState(
    transaction?.remittance ? transaction?.remittance.includeFee : true
  );
  const [sendAmount, setSendAmount] = useState(
    transaction?.remittance.remit ? transaction?.remittance?.remit?.amount : ""
  );
  const [recieveAmount, setRecieveAmount] = useState(
    transaction?.remittance?.settlement
      ? transaction?.remittance?.settlement?.amount
      : ""
  );

  const sendLocations =
    locations &&
    locations?.filter(
      (location) =>
        location?.currency.from === true && location.status === "ACTIVE"
    );
  const recipientLocations =
    locations &&
    locations.filter(
      (location) =>
        location?.currency.to === true && location.status === "ACTIVE"
    );
  const [recipientLocation, setRecipientLocation] = useState(
    transaction?.location
  );
  const [sendLocation, setSendLocation] = useState(
    sendLocations.find((location) => location.locationName === "UNITED_KINGDOM")
  );
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState<any>(
    transaction?.remittance?.deliveryMethod
  );

  const calculateReceiveAmount = (value) => {
    if (receiveInputFocused) {
      return false;
    }
    const amount = (parseFloat(value) * parseFloat(exchangeRate)).toString();
    setRecieveAmount(amount);
  };

  useEffect(() => {
    if (!swapRate) {
      setExchangeRate(
        calculateExchangeRate(
          1,
          // Target GBP to ensure that excahnge rate when sending to from GBP remain 1;
          sendLocation?.currency.currencyCode === "GBP"
            ? 1
            : sendLocation?.currency.sellFxRate,
          recipientLocation?.currency.sellFxRate
        ).toString()
      );
    } else {
      setExchangeRate(
        calculateExchangeRate(
          1,
          // Target GBP to ensure that excahnge rate when sending to from GBP remain 1;
          recipientLocation?.currency.sellFxRate,
          sendLocation?.currency.currencyCode === "GBP"
            ? 1
            : sendLocation?.currency.sellFxRate
        ).toString()
      );
    }
    if (
      transaction?.location?.locationName !== recipientLocation?.locationName
    ) {
      setSendAmount("");
      setRecieveAmount("");
    }
  }, [sendLocation, recipientLocation, swapRate]);
  useEffect(() => {
    setSendLocation(sendLocations[1]);
    setRecipientLocation(
      transaction?.location ? transaction.location : recipientLocations[0]
    );
  }, [locations, transaction]);
  useEffect(() => {
    setFee(calculateFee(selectedDeliveryMethod?.fees, sendAmount));
  }, [sendAmount, sendLocation, selectedDeliveryMethod]);
  useEffect(() => {
    calculateReceiveAmount(sendAmount);
  }, [isFeeIncluded, fee]);
  useEffect(() => {
    setSelectedDeliveryMethod(
      transaction?.remittance
        ? transaction?.remittance.deliveryMethod
        : recipientLocation?.deliveryMethods[0]
    );
  }, [recipientLocation, transaction]);
  return (
    <div className="pb-2 calculator mb-3 ">
      <section
        className="p-4 d-flex justify-content-center mb-4 rate-section bg-secondary text-white"
        style={{
          position: "relative",
        }}
      >
       {
        sendLocation?.currency?.currencyCode &&
        <h4 className="m-0">
          {" "}
          {!swapRate
            ? `${sendLocation?.currency?.currencyCode} 1 = ${
                recipientLocation?.currency?.currencyCode
              } ${numberFormatter(exchangeRate)}`
            : `${recipientLocation?.currency?.currencyCode} 1 = ${
                sendLocation?.currency?.currencyCode
              } ${numberFormatter(exchangeRate)}`}
        </h4>
       }
        <div
          className=""
          style={{
            position: "absolute",
            right: 20,
            top: 22,
          }}
          onClick={() => {
            setSwapRate(!swapRate);
          }}
        >
          {
            swapRate ? <ArrowCounterclockwise size={30} color={'#0a1849'} /> : <ArrowClockwise size={30} color={'#0a1849'} />
          }

        </div>
      </section>
      <section className="px-3">
        <section className="mb-3">
          <div className="input-group is-invalid border rounded border-primary">
            <input
              type="number"
              className="form-control form-control-lg"
              placeholder="You Send"
              autoComplete="off"
              required
              onChange={(e) => {
                setSendAmount(e.target.value);
                calculateReceiveAmount(e.target.value);
              }}
              value={isNaN(parseInt(sendAmount)) ? "" : sendAmount}
            />

            <div className="input-group-append">
              <button
                style={{ minWidth: "110px" }}
                className="btn btn-primary d-flex align-items-center justify-content-center"
                type="button"
                onClick={() => {
                  setShowCurrencyDropDown(!showCurrencyDropDown);
                  setDropdownType("send");
                }}
              >
                <img src={sendLocation?.flagUrl} alt="" height="12" />
                <span className="mx-1">
                  {sendLocation?.currency?.currencyCode}
                </span>
                <ChevronDown />
              </button>
            </div>
          </div>
        </section>

        <section className="mb-3 position-relative">
          <div className="input-group is-invalid  border rounded border-primary">
            <input
              type="number"
              className="form-control form-control-lg"
              id="validatedInputGroupCustomFile"
              placeholder="Recipient gets"
              autoComplete="off"
              value={isNaN(parseFloat(recieveAmount)) ? "" : recieveAmount}
              onFocus={() => {
                setReceiveInputFocused(true);
              }}
              onBlur={() => {
                setReceiveInputFocused(false);
              }}
              onChange={(e) => {
                setRecieveAmount(e.target.value);
                setSendAmount(
                  (
                    parseFloat(e.target.value) / parseFloat(exchangeRate)
                  ).toString()
                );
              }}
            />

            <div className="input-group-append">
              <button
                style={{ minWidth: "110px" }}
                className="btn btn-primary d-flex align-items-center justify-content-center"
                type="button"
                onClick={() => {
                  setShowCurrencyDropDown(!showCurrencyDropDown);
                  setDropdownType("recieve");
                }}
              >
                <img src={recipientLocation?.flagUrl} alt="" height="12" />
                <span className="mx-1">
                  {recipientLocation?.currency?.currencyCode}
                </span>{" "}
                <ChevronDown />
              </button>
            </div>
          </div>

          {showCurrencyDropDown && (
            <CurrencySelector
              locations={
                dropdownType === "recieve" ? recipientLocations : sendLocations
              }
              onSelect={(location) => {
                console.log(location);
                if (dropdownType === "recieve") {
                  setRecipientLocation(location);
                  setShowCurrencyDropDown(false);
                } else {
                  setSendLocation(location);
                  setShowCurrencyDropDown(false);
                }
              }}
              selectedLocation={
                dropdownType === "recieve" ? recipientLocation : sendLocation
              }
            />
            // <div
            //   className="position-absolute bg-white w-100 shadow p-3"
            //   style={{ zIndex: 100, borderRadius: 20 }}
            // >
            //   {recipientLocations.map((location, index) => {
            //     return (
            //       <div
            //         key={index}
            //         className={`row align-items-center my-2 cursor-pointer p-2 ${
            //           recipientLocation === location && "bg-light"
            //         }`}
            //         onClick={() => {
            //           setRecipientLocation(location);
            //           setShowCurrencyDropDown(false);
            //         }}
            //       >
            //         <div className="col-3 d-flex align-items-center">
            //           <img src={location.flagUrl} alt="" height="12" />
            //           <p className="m-0 font-weight-bold text-dark mx-3">
            //             {location.currency.currencyCode}
            //           </p>
            //         </div>
            //         <div className="col-7">
            //           <p className="m-0">{location.locationLabel}</p>
            //         </div>
            //         <div className="col-1">
            //           {recipientLocation === location && (
            //             <CheckCircleFill className="text-success" />
            //           )}
            //         </div>
            //       </div>
            //     );
            //   })}
            // </div>
          )}
        </section>
        {/* select develivery method start */}
        <section className="d-flex row justify-content-between align-items-center mb-5 mt-4">
          <div className="col-3">
            <label className="m-0">Delivery</label>
          </div>
          <div className="col-9">
            <Dropdown
              options={
                recipientLocation?.deliveryMethods?.map(
                  (method) => method.label
                ) ?? []
              }
              value={""}
              placeholder="Select Delivery Method"
            />
          </div>
        </section>
      </section>
    </div>
  );
};

const CurrencySelector = ({ locations, selectedLocation, onSelect }) => {
  return (
    <div
      className="position-absolute bg-white w-100 shadow p-3"
      style={{ zIndex: 100, borderRadius: 20 }}
    >
      {locations.map((location, index) => {
        return (
          <div
            key={index}
            className={`row align-items-center my-2 cursor-pointer p-2 ${
              selectedLocation === location && "bg-light"
            }`}
            onClick={() => onSelect(location)}
          >
            <div className="col-3 d-flex align-items-center">
              <img src={location.flagUrl} alt="" height="12" />
              <p className="m-0 font-weight-bold text-dark mx-3">
                {location.currency.currencyCode}
              </p>
            </div>
            <div className="col-7">
              <p className="m-0">{location.locationLabel}</p>
            </div>
            <div className="col-1">
              {selectedLocation === location && (
                <CheckCircleFill className="text-success" />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default Calculator;
